import { Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';
import cn from 'classnames';
import React from 'react';

import styles from './SubHeading.module.scss';

type Props = {
  subHeadingText?: string;
  moreToggleText?: string;
};

export const SubHeading: FC<Props> = (props) => {
  const { subHeadingText, moreToggleText = 'Eщё', className } = props;

  const [isOpen, setIsOpen] = useBoolean(!subHeadingText);

  return (
    <div className={cn(styles.wrapper, className)}>
      <Typography.Text
        size={14}
        className={cn({
          [styles.hidden]: !isOpen,
        })}
        onClick={isOpen ? setIsOpen.toggle : undefined}
      >
        {subHeadingText}
      </Typography.Text>
      {!isOpen && (
        <div className={styles.moreTextWrapper}>
          <Typography.Text
            size={14}
            className={styles.moreText}
            onClick={setIsOpen.toggle}
          >
            {moreToggleText}
          </Typography.Text>
        </div>
      )}
    </div>
  );
};
